<script>
	import { onMount } from "svelte";

	import Animation from "../../components/Animation.svelte";
	import Animatable from "../../components/Animatable.svelte";

	export let id;
	export let color;
	export let background;
	export let animationDuration = 2000;
	export let forSubscribers;

	export let content = {};

	let playDesktop;
	let playTablet;
	let playMobile;

	const f = 1.5;

	const animationNational = {
		translateY: {
			0: "0px",
			0.3: `-${f * 105}px`,
			1: `-${f * 105}px`,
		},
		translateX: {
			0: "0px",
			0.3: "0px",
			1: "0px",
		},
	};

	const animationRegional = {
		translateY: {
			0: "0px",
			0.3: `-${f * 105}px`,
			1: `-${f * 185}px`,
		},
		translateX: {
			0: "0px",
			0.3: "0px",
			1: `${f * 80}px`,
		},
	};

	const animationIpad = {
		translateY: {
			0: "0px",
			0.3: `-${f * 105}px`,
			1: `-${f * 185}px`,
		},
		translateX: {
			0: "0",
			0.3: "0",
			1: `-${f * 100}px`,
		},
	};

	///NEW

	const animationNational2 = {
		translateY: {
			0: `-${f * 50}px`,
			0.5: `-${f * 105}px`,
			1: `-${f * 105}px`,
		},
		easing: "cubic-bezier(.29,0,.26,1)",

		translateX: {
			0: "0px",
			0.35: "0px",
			1: "0px",
		},
	};

	const animationRegional2 = {
		translateY: {
			0: "0px",
			//0.3: `-${f * 105}px`,
			0.35: { value: `-${f * 110}px`, easing: "cubic-bezier(.71,0,.58,1.01)" },
			0.7: { value: `-${f * 155}px`, easing: "cubic-bezier(.5,-0.01,.46,1)" },
		},
		translateX: {
			0: `${f * 5}px`,
			0.35: `${f * 5}px`,
			0.7: { value: `${f * 70}px`, easing: "cubic-bezier(.18,.63,.37,1)" },
		},
		opacity: {
			0: 0,
			0.35: 0,
			0.5: 1,
		},
		// rotate: {
		// 	0: 0deg,
		// 	//0.3: `-${f * 105}px`,
		// 	0.4: {value: 0deg, easing: 'cubic-bezier(.58,.16,.82,.94)'},
		// 	0.75: {value: `90deg`, easing: 'cubic-bezier(.55,.19,.42,1)'},
		// },
	};

	const animationIpad2 = {
		translateY: {
			0: `-${f * 50}px`,
			0.5: `-${f * 105}px`,
			1: { value: `-${f * 180}px`, easing: "cubic-bezier(.48,0,.23,1)" },
		},
		translateX: {
			0: "0",
			0.5: "0",
			1: { value: `-${f * 110}px`, easing: "cubic-bezier(.48,0,.01,1.01)" },
		},
		opacity: {
			0: 0,
			0.45: 0,
			0.8: 1,
		},
	};

	const easing = "cubic-bezier(0.585, -0.010, 0.070, 1.000)";

	let elem;
	let imagesLoaded = 0;
	let showcta = false;

	function inc() {
		imagesLoaded += 1;
	}

	function go() {
		showcta = true;
		playDesktop();
		playTablet();
		playMobile();
	}

	// handle cached images
	onMount(() => {
		elem.querySelectorAll("img.anim").forEach((i) => {
			if (i.complete) inc();
		});
	});

	$: imagesLoadedBounded = Math.min(imagesLoaded, 3);
	$: imagesLoadedBounded === 3 && setTimeout(go);
</script>

<section {id} style:color bind:this={elem} class:showcta>
	<div class="header-container">
		<div class="header">
			<div class="kicker t-kicker">{content.kicker}</div>
			<div class="title t-title">{content.title}</div>
		</div>
	</div>

	<div class="animation-container">
		<div class="hide-on-mobile hide-on-tablet">
			<Animation duration={animationDuration} bind:play={playDesktop}>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationIpad2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_ipad_desktop.png"
						alt=""
						width={130 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationRegional2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_regional_desktop_255.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationNational2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_national_desktop.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
			</Animation>
		</div>
		<div class="hide-on-mobile hide-on-desktop">
			<Animation duration={animationDuration} {easing} bind:play={playTablet}>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationIpad2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_ipad_desktop.png"
						alt=""
						width={130 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationRegional2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_regional_desktop_255.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationNational2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_national_desktop.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
			</Animation>
		</div>
		<div class="hide-on-desktop hide-on-tablet">
			<Animation duration={animationDuration} {easing} bind:play={playMobile}>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationIpad2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_ipad_desktop.png"
						alt=""
						width={130 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationRegional2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_regional_desktop_255.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
				<Animatable anchor="center center" left="50%" top="calc(50% + {f * 120}px)" animation={animationNational2}>
					<img
						class="anim"
						src="{PATH}assets/images/content/intro_cover_national_desktop.png"
						alt=""
						width={200 * f}
						on:load={inc}
					/>
				</Animatable>
			</Animation>
		</div>

		{#if !forSubscribers}
			<div class="cta">
				<a class="button" href={content.ctaButtonLink} target="_blank" rel="noopener">
					{content.ctaButtonText}
				</a>
			</div>
		{/if}
	</div>

	<div class="x" />
</section>

<style lang="scss">
	section {
		text-align: center;
		height: 100vh;
		min-height: 1000px;
		display: flex;
		flex-direction: column;
		overflow: visible !important;

		@media (max-width: $breakpoint-mobile) {
			min-height: 665px;
		}
	}

	.header-container {
		background: #fff;

		min-height: 337px;

		@media (max-width: $breakpoint-tablet) {
			min-height: 314px;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 232px;
		}

		@media (max-width: 441px) {
			min-height: 278px;
		}
	}

	.header {
		width: calc(100% - 20px);
		max-width: 650px;
		margin: 120px auto 50px;
		flex: 0 0 auto;

		@media (max-width: $breakpoint-mobile) {
			margin: 90px auto 30px;
			width: calc(100% - 40px);
		}
	}

	.x {
		flex: 0 0 20px;
		display: none;

		@media (max-width: $breakpoint-mobile) {
			display: block;
		}
	}

	.animation-container {
		flex: 1 0 1px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: visible;
	}

	@media (max-width: $breakpoint-mobile) {
		.animation-container {
			//overflow: hidden;

			:global(.animation) {
				transform: scale(0.6);
				transform-origin: center center;
			}
		}
	}

	.button {
		border-radius: 5px;
		text-align: center;
		font-family: $ff-sans;
		color: #f2f2f2;
		padding: 10px 50px;
		font-size: 16px;
		line-height: 20px;
		display: inline-block;
		font-weight: 500;
		text-decoration: none !important;
		touch-action: manipulation;
		cursor: pointer;
		box-sizing: border-box;
		display: inline-block;
		white-space: nowrap;
		background-color: transparent;
		color: #f2f2f2;
		border: 1px solid #f2f2f2;
		transition: background-color 0.3s ease;

		&:active,
		&:hover {
			outline: 0;
		}

		&:hover {
			color: #fff;
			border-color: #fff;
			background-color: rgba(255, 255, 255, 0.2);
		}
	}

	.cta {
		position: absolute;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 80px;
		opacity: 0;
		pointer-events: none;
		transition: opacity 1s 1.4s ease;
		z-index: 1;

		@media (max-width: $breakpoint-mobile) {
			bottom: auto;
			top: calc(50% + 150px);
		}
	}

	@keyframes ctabuttonpulei {
		0% {
			box-shadow: 0 0 40px rgba(255, 255, 255, 0.1);
		}
		15% {
			box-shadow: 10px 10px 45px rgba(255, 255, 255, 0.17);
		}
		30% {
			box-shadow: -17px -10px 50px rgba(255, 255, 255, 0.18);
		}
		45% {
			box-shadow: -15px 8px 65px rgba(255, 255, 255, 0.16);
		}
		60% {
			box-shadow: 13px 12px 45px rgba(255, 255, 255, 0.18);
		}
		75% {
			box-shadow: 15px -12px 57px rgba(255, 255, 255, 0.14);
		}
		90% {
			box-shadow: -9px 5px 67px rgba(255, 255, 255, 0.19);
		}
		100% {
			box-shadow: 0 0 40px rgba(255, 255, 255, 0.1);
		}
	}

	.showcta {
		.cta {
			opacity: 1;
			pointer-events: all;
		}
		.button {
			animation: ctabuttonpulei 5.5s 0s ease infinite;
		}
	}
</style>
